import { Suspense, useMemo, useState } from 'react';
import { GameSessionNavProvider } from '@stans-world/sdk/react';
import { useAuth } from '../auth/AuthContext';
import { useShellSidebar } from '../shell/ShellSidebarContext';
import GameRouteLoading from './GameRouteLoading';

function GameFrameMobileMenu() {
  const shell = useShellSidebar();
  if (!shell) return null;
  const { sidebarOpen, toggleSidebar } = shell;
  return (
    <button
      type="button"
      className="mobile-menu-btn game-frame-mobile-menu-btn"
      aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={sidebarOpen}
      aria-controls="app-sidebar"
      onClick={() => toggleSidebar()}
    >
      <span className="mobile-menu-btn__icon" aria-hidden="true" />
    </button>
  );
}

function GameRouteGate({ children }) {
  const { authChecked } = useAuth();
  const [backToHubDisabled, setBackToHubDisabled] = useState(false);
  const sessionNavValue = useMemo(
    () => ({ backToHubDisabled, setBackToHubDisabled }),
    [backToHubDisabled],
  );

  // Auth is no longer a barrier to play; we still wait for the initial
  // session check so the game renders with consistent platform context.
  if (!authChecked) {
    return (
      <main className="page-view game-frame-root">
        <div className="game-frame-embed" aria-busy="true" aria-live="polite" aria-label="Loading">
          <GameFrameMobileMenu />
          <GameRouteLoading />
        </div>
      </main>
    );
  }

  return (
    <GameSessionNavProvider value={sessionNavValue}>
      <main className="page-view game-frame-root">
        <div className="game-frame-embed">
          <GameFrameMobileMenu />
          <Suspense fallback={<GameRouteLoading label="Loading game…" />}>{children}</Suspense>
        </div>
      </main>
    </GameSessionNavProvider>
  );
}

export default GameRouteGate;
